import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CrudService } from "./crud.service";
import { environment } from "../../environments/environment";
import { Ticket } from "../models/ticket";

@Injectable({
  providedIn: "root",
})
export class TicketsService extends CrudService<Ticket, number> {
  constructor(protected override _http: HttpClient) {
    super(_http, `${environment.baseUrl}/tickets`);
  }
}
